import FinderViewBase from '../FinderViewBase/FinderViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EmploymentFinderHome.html?raw';

class EmploymentFinderHome extends compose(FinderViewBase) {
	templateString: any = template;

    calendarContainer: HTMLElement; // will be passed as a function parameter
    tableContainer: HTMLElement; // will be passed as a function parameter

    _isCalendarctive: boolean;
    _isTableActive: boolean;
    buttonClickTimeout: number = null;

    // damit man die Name und containerNode im Bedarfsfall nur an einer Stelle ändern muss
    bookingsCalendarParams: calendarParams = { sContainerNodeName: "calendarContainer", domNodeHeight: 500, showButtons: true };
    employmentTableParams: tableParams = { widgetName: "employmentTable", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "items";
    tableEntityPath = "Entity";
    loadFilterDatatUrl = "EmploymentFinder/GetEmploymentList";
    loadFinderConfigUrl = "EmploymentFinder/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["AddressFinder_BtnSubmitNext"];
    btnSubmitLabelText = (this as any).translations["AddressFinder_BtnSubmit"];
    calendar_columnViewHeadTextAttr: string = "columnview_head_text";
    calendar_columnViewBodyTextAttr: string = "columnview_body_text";

    filterOptionSearch = "dateRange";
    filterOptionDateStart: string = "date_start"; // default
    filterOptionDateEnd: string = "date_end"; // default

    employmentTable_formatterFunction(cell: StaticTable.StaticTableCell<orchestraEmployment>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            case "actions":
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": this.translations["Generic_show"],
                    "class": "mds-button-base round w3-center sL3 mds-hover-dark w3-large",
                    "onclick": lang.hitch(this, "tableRowButton_click", cell.tableRow),
                    "title": this.translations["Generic_show"],
                }, node);

                this.UiModder.domConstruct.create("I", { "class": "far fa-calendar-alt" }, btn);
                return true;
                break;
           
            default:
                return false;
        }
    }
    // -------------------------------------- METHODS -----------------------------------------------
    // overrides -----------------------------------------------start
    filterOptions_additionalConfig(): void { //Base
        // weil am anfang die tabelle ausgewählt ist
        let displayDateOption = this.getFilterOptionByName("displayDate");
        if (displayDateOption) {
            displayDateOption.set("readonly", true);
            displayDateOption.on("change", lang.hitch(this, function () {
                console.log(displayDateOption["data"], this.calendar)
                if (this.calendar) {
                    this.calendar.setDate(displayDateOption.getValue())
                }
            }))
        }

        let highLightOption = this.getFilterOptionByName("highlightItems");
        if (highLightOption) {
            highLightOption.set("readonly", true);
            highLightOption.on("change", lang.hitch(this, function (change) {
                this._onCalenderHighlightItemChange(highLightOption.getValue());
                setTimeout(lang.hitch(this, function () { this.checkDirtyState(false); }), 170)
            }))
        }


        let viewOption = this.getFilterOptionByName("view")
        if (viewOption) viewOption.on("change", lang.hitch(this, function () {
            this._onViewChange(viewOption)
        }))

        // weil sonst keine daten gibt - für demo
        var option = this.getFilterOptionByName("functional_group");
        if (option) option.set("value", "0000029d:00000046");
    }

    _onViewChange(option) {
        let displayDateOption = this.getFilterOptionByName("displayDate");
        let startTimeOption = this.getFilterOptionByName(this.filterOptionDateStart);
        let endTimeOption = this.getFilterOptionByName(this.filterOptionDateEnd);
        let tableLayoutOption = this.getFilterOptionByName("tableLayout");
        var highLightOption = this.getFilterOptionByName("highlightItems");
        switch (option.data.value) {
            case "calendar":
                this.showCalendar(true);
                if (displayDateOption) displayDateOption.set("readonly", false);
                if (highLightOption) highLightOption.set("readonly", this.calendar && this.calendar.lastHighlightedCalendarItem_ID == null);
                if (startTimeOption) startTimeOption.set("readonly", true);
                if (endTimeOption) endTimeOption.set("readonly", true);
                if (tableLayoutOption) tableLayoutOption.set("readonly", true);
                break;
            case "table":
                this.showTable(true, false);
                if (displayDateOption) displayDateOption.set("readonly", true);
                if (highLightOption) highLightOption.set("readonly", true); highLightOption.set("value", false);
                if (startTimeOption) startTimeOption.set("readonly", false);
                if (endTimeOption) endTimeOption.set("readonly", false);
                if (tableLayoutOption) tableLayoutOption.set("readonly", false);
                break;
        }
    }

    /*
    // Evens der Filterpanel fangen
    _onOptionValueChange(dataObj: filterPanel_option_valuechange_obj): void { //Base

        if (dataObj) {
            if (dataObj.name == "resultviewParameter") {
                switch (dataObj.option) {
                    case "view":
                        if (dataObj.optionValue == "calendar") {

                            let startTimeOption = this.getFilterOptionByName(this.filterOptionDateStart);
                            let endTimeOption = this.getFilterOptionByName(this.filterOptionDateEnd);
                            if (startTimeOption) startTimeOption.set("readonly", true);
                            if (endTimeOption) endTimeOption.set("readonly", true);
                            let displayDateOption = this.getFilterOptionByName("displayDate");
                            if (displayDateOption) displayDateOption.set("readonly", false);
                            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
                            if (tableLayoutOption) tableLayoutOption.set("readonly", true);
                            if (this._isTableActive) this.showCalendar();

                        } else if (dataObj.optionValue == "table") {

                            let startTimeOption = this.getFilterOptionByName(this.filterOptionDateStart);
                            let endTimeOption = this.getFilterOptionByName(this.filterOptionDateEnd);
                            if (startTimeOption) startTimeOption.set("readonly", false);
                            if (endTimeOption) endTimeOption.set("readonly", false);
                            let displayDateOption = this.getFilterOptionByName("displayDate");
                            if (displayDateOption) displayDateOption.set("readonly", true);
                            let highlightItemsOption = this.getFilterOptionByName("highlightItems");
                            if (highlightItemsOption) {
                                highlightItemsOption.set("value", false);
                                highlightItemsOption.set("readonly", true);
                            }
                            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
                            if (tableLayoutOption) tableLayoutOption.set("readonly", false);
                            if (this._isCalendarctive) this.showTable(true, true);
                        }
                        break;
                    case "tableLayout":

                        if (this._isTableActive) this.createTable(this.employmentTableParams.widgetName, this[this.employmentTableParams.sContainerNodeName], dataObj.optionValue, this._completeList, this.employmentTable_formatterFunction);

                        break;
                    case "displayDate":
                        if (this.bookingsCalendarParams) {
                            if (this.calendar && this._isCalendarctive) this.calendar.setDate(dataObj.optionValue);
                        } else {
                            alert("calenadr params?")
                        }
                        break;
                    case "highlightItems":
                        this._onCalenderHighlightItemChange(dataObj.toggleSelected);
                        break;
                }
            } else if (dataObj.name == "searchParameter") {
                switch (dataObj.option) {
                    case "searchText":
                        if (this._isCalendarctive == true) {
                            this.dateRangeStart = null;
                            this.dateRangeEnd = null;
                        }
                        break;
                }
            }
        }
    }*/

    _onClick_Submit(evt: Event) { // Base

        if (this._isRequestActive === true || (this.getDirty() != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        var viewSelectOption = this.getFilterOptionByName("view"); 
        if (viewSelectOption) {

            if (viewSelectOption.getValue() == "calendar") {
                this.showCalendar();
            } else if (viewSelectOption.getValue() == "table") {
                this.showTable();
            }
        } else {
            alert("No View selected");
        }
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.employmentTableParams) {
            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
            var selectedLayout: string = <string>tableLayoutOption.getValue();

            // z.B. gleich eine Tabelle kreieren
            let table = this.createTable(this.employmentTableParams.widgetName, this[this.employmentTableParams.sContainerNodeName], selectedLayout, this._completeList, this.employmentTable_formatterFunction);
            table.setRowClick(lang.hitch(this, this.tableRow_click));
            this.checkDirtyState(false);
        } else {
            alert("table params?")
        }
    }
    // --------------overrides ------------------------------------end
    // --------------------own methods ----------------------------start

    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    showTable(bool?: boolean, useLastResponse?:boolean): void {
        if (this.employmentTableParams) {
            if (bool === false) {
                if (this._isTableActive) {
                    if (this[this.employmentTableParams.sContainerNodeName]) {
                        this.UiModder.domClass.add(this[this.employmentTableParams.sContainerNodeName], "w3-hide");
                        if (this._isCalendarctive == false) this.showCalendar();
                        this._isTableActive = false;
                    } else {
                        console.log("no DomNode found for this.", this.employmentTableParams.sContainerNodeName)
                    }
                }
            } else {
                if (useLastResponse) {
                    this.processFilterListResponse(this.lastResponse);
                } else {
                    this.getFilterlist();
                }
                this._isTableActive = true;
                if (this._isCalendarctive) this.showCalendar(false);
            }
        } else {
            alert("calendar params?")
        }
    }

    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    showCalendar(bool?: boolean): void {
        if (this.bookingsCalendarParams) {

            if (bool === false) {
                if (this._isCalendarctive) {
                    if (this[this.bookingsCalendarParams.sContainerNodeName]) {
                        this.UiModder.domClass.add(this[this.bookingsCalendarParams.sContainerNodeName], "w3-hide");
                        this._isCalendarctive = false;
                        if (this._isTableActive === false) this.showTable(true);

                    } else {
                        console.log("no DomNode found for this.", this.bookingsCalendarParams.sContainerNodeName)
                    }
                }
            } else {
                var displayDateOption = this.getFilterOptionByName("displayDate");
                var displayDate: string = null;
                if (displayDateOption && displayDateOption.selected && displayDateOption.getValue()) {
                    displayDate = <string>displayDateOption.getValue();
                }
                this.createCalendar(
                    this[this.bookingsCalendarParams.sContainerNodeName],
                    this.bookingsCalendarParams.domNodeHeight,
                    this.bookingsCalendarParams.showButtons,
                    this.bookingsCalendarParams.calendarMode,
                    displayDate
                );
                this._isCalendarctive = true;
                if (this._isTableActive) this.showTable(false);
            }
        } else {
            alert("calendar params?")
        }
    }

    private tableRow_click(rowData: StaticTable.StaticTableRow<orchestraEmployment>): void {
        //console.debug("tableRow_click", rowData);

        this.tableRowButton_click(rowData, null);
    }

    tableRowButton_click(rowData: StaticTable.StaticTableRow<orchestraEmployment>, evt: MouseEvent): void {
        let entity = rowData.rowGroup.entity;

        if (evt) {
            evt.stopPropagation();
        }

        let viewOption = this.getFilterOptionByName("view");
        if (viewOption) viewOption.set("value", "calendar");

        let highlightOption = this.getFilterOptionByName("highlightItems");
        if (highlightOption) {
            highlightOption.set("value", true);
            highlightOption.set("readonly", false);
        }

        if (this.buttonClickTimeout != null) {
            clearTimeout(this.buttonClickTimeout);
        }

        this.buttonClickTimeout = setTimeout(lang.hitch(this, function () {
            if (this.calendar) {
                this.calendar.setDate(entity.date_start);
                this.calendar.setItemToHighlight(entity.ID);
            }
        }), 500)
    }
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EmploymentFinderHome);